<template>
    <el-dialog 
      @close="closeDialog" 
      :before-close="childDialogClick" 
      width="70rem" 
      class="dialog-one" 
      v-model="clientDialogInfo.dialogClient" 
      :show-close="false" 
    >
    <div v-draggable>
      <el-tabs v-model="clientDialogInfo.clientActiveName" type="card">
        <el-tab-pane :label="$t('MANUAL.CLIENTLIST')" name="first">
          <el-row>
            <el-col :span="6" class="search-input">
              <div>{{ $t("MANUAL.SEARCHCLIENTNO") }}</div>
              <el-input v-model="clientDialogInfo.searchClientNo"></el-input>
            </el-col>
            <el-col :span="6" class="search-input">
              <div>{{ $t("MANUAL.SEARCHCLIENT") }}</div>
              <el-input v-model="clientDialogInfo.searchClient"></el-input>
            </el-col>
            <el-col :span="4" class="search-btn search-el" @click="getCustomerList(1)">
              <el-button class="" style="">
                {{ $t("USERDIALOG.BTNSEARCH") }}
              </el-button>
            </el-col>
          </el-row>
          <el-table :data="clientDialogInfo.clientData">
            <el-table-column prop="customerCode" :label="$t('MANUAL.SEARCHCLIENTNO')" width="290"></el-table-column>
            <el-table-column prop="customerName" :label="$t('MANUAL.SEARCHCLIENT')" width="290"></el-table-column>
            <el-table-column width="120" :label="$t('USERDIALOG.OPERATION')">
              <template #default="scope">
                <div class="select-btn" @click="selectClient(scope.row)">
                  {{ $t("USERDIALOG.SELECT") }}
                </div>
              </template>
            </el-table-column>
          </el-table>
          <el-row style="float: right; margin: 2%">
            <el-pagination
              background
              layout="prev, pager, next"
              :total="clientDialogInfo.pagination.total"
              :page-size="clientDialogInfo.pagination.pageSize"
              :current-page="clientDialogInfo.pagination.currentPage"
              @current-change="pageChange_clientDialog"
            >
            </el-pagination>
          </el-row>
        </el-tab-pane>
      </el-tabs>
    </div>
    </el-dialog>
</template>

<script>
import { getCustomerLookup } from "@/api/platformData.js";

export default {
  name: "ClientList",
  data() {
    return {
      clientDialogInfo: {
        dialogClient: false,
        clientActiveName: "first",
        searchClientNo: "", //name search
        searchClient: "", //tel search
        clientData: [],
        pagination: {
          total: 0, //总数
          pageSize: 5,
          currentPage: 1,
        }, //分页信息
      },
    };
  },
  props: {
    customerDialogVisible: Boolean,
  },
  watch: {
    // 弹出客户姓名窗口方法
    customerDialogVisible(newVal) {
      this.clientDialogInfo.dialogClient = newVal;
      if(newVal){
        this.getCustomerList(1);
      }
    },
  },
  methods: {
    closeDialog(){
     this.clientDialogInfo.searchClientNo = "";
     this.clientDialogInfo.searchClient = "";
    },
    //选择客户
    selectClient(item) {
      this.$emit("customerInfo", {
        customerCode: item.customerCode,
        customerName: item.customerName,
        ordApprovalType: item.ordApprovalType,
        strongControl: item.strongControl,
        customerFees: item.customerFees,
        isCorpPay: item.isCorpPay,
        customerTcs: item.customerTcs,
        linkerValue: item.linkerValue,
      });
      this.childDialogClick();
    },
    async getCustomerList(currPage) {
      let customerParam = {
        params: {
          page: currPage,
          per_page: this.clientDialogInfo.pagination.pageSize,
          customerCode: this.clientDialogInfo.searchClientNo,
          customerName: this.clientDialogInfo.searchClient,
        },
      };
      
      try {
        const res = await getCustomerLookup(customerParam);
        console.log("客户信息", res.data);
        this.clientDialogInfo.pagination.total = res.data.total; //总数
        this.clientDialogInfo.pagination.pageSize = res.data.pageSize;
        this.clientDialogInfo.pagination.currentPage = res.data.pageNumber;
        this.clientDialogInfo.clientData = res.data.customerDetails;
      } catch (error) {
        console.log("客户信息 请求失败", error.objError);
      }
    },
    //客户列表分页切换
    pageChange_clientDialog(currPage) {
      this.getCustomerList(currPage);
    },
    childDialogClick() {
      this.clientDialogInfo.dialogClient = false;
      this.$emit("setCustomerFlag", this.clientDialogInfo.dialogClient);
    },
  },
};
</script>

<style scoped lang="stylus">
:deep(.dialog-one .el-dialog__body) {
  padding: 0px;
}
.search-input {
  margin-left: 10%;
}
.search-btn {
  margin: 2% 5%;

  button {
    padding: 7px 20px;
    border: 1px solid $btn-bg-color;
    color: $btn-bg-color;
  }
}
.search-el {
  padding-top: 0.3rem;
  margin: 2% 5%;
}
.select-btn {
  color: $btn-bg-color;
  cursor: pointer;
}
.is-scrolling-left{
  overflow-x: hidden !important;
}
</style>